import { useEffect } from 'react';
import { useSidebarPermission } from '../Context/SidebarPermissionContext';
import { useNavigate } from 'react-router-dom';

const usePermissionForPages = (requiredPermissions, redirectTo) => {
  const { permissions } = useSidebarPermission();
  const navigate = useNavigate();

  useEffect(() => {
    const hasRequiredPermissions = requiredPermissions.every((requiredPermission) => {
      const userPermission = permissions.find(permission => permission.permission === requiredPermission);
      return userPermission ? userPermission.allow : false;
    });

    if (!hasRequiredPermissions && permissions.length > 0) {
      navigate(redirectTo);
    }
  }, [permissions, requiredPermissions, redirectTo, navigate]);
};

export default usePermissionForPages;
